import { useRequest } from 'liyu-pc-base/init-plugin';

export async function create_approval_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/create_approval_group', params);
}

export async function update_approval_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/update_approval_group', params);
}

export async function delete_approval_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/delete_approval_group', params);
}

export async function recover_approval_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/recover_approval_group', params);
}

export async function query_approval_group_list(params?: { [key: string]: any }): Promise<any> {
  return useRequest().post('/oa_integration/query_approval_group_list', params);
}

export async function query_approval_group_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_approval_group_group', params);
}

export async function query_approval_group_count(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_approval_group_count', params);
}

export async function get_approval_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/get_approval_group', params);
}

export async function create_ding_approval(params: Record<string, any>) {
  return useRequest().post('/oa_integration/create_ding_approval', params);
}

export async function update_ding_approval(params: Record<string, any>) {
  return useRequest().post('/oa_integration/update_ding_approval', params);
}

export async function delete_ding_approval(params: Record<string, any>) {
  return useRequest().post('/oa_integration/delete_ding_approval', params);
}

export async function recover_ding_approval(params: Record<string, any>) {
  return useRequest().post('/oa_integration/recover_ding_approval', params);
}

export async function query_ding_approval_list(params?: { [key: string]: any }): Promise<any> {
  return useRequest().post('/oa_integration/query_ding_approval_list', params);
}

export async function query_ding_approval_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_approval_group', params);
}

export async function query_ding_approval_count(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_approval_count', params);
}

export async function get_ding_approval(params: Record<string, any>) {
  return useRequest().post('/oa_integration/get_ding_approval', params);
}

export async function create_ding_approval_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/create_ding_approval_org', params);
}

export async function update_ding_approval_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/update_ding_approval_org', params);
}

export async function delete_ding_approval_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/delete_ding_approval_org', params);
}

export async function recover_ding_approval_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/recover_ding_approval_org', params);
}

export async function query_ding_approval_org_list(params?: { [key: string]: any }): Promise<any> {
  return useRequest().post('/oa_integration/query_ding_approval_org_list', params);
}

export async function query_ding_approval_org_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_approval_org_group', params);
}

export async function query_ding_approval_org_count(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_approval_org_count', params);
}

export async function get_ding_approval_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/get_ding_approval_org', params);
}

export async function create_ding_approval_record(params: Record<string, any>) {
  return useRequest().post('/oa_integration/create_ding_approval_record', params);
}

export async function update_ding_approval_record(params: Record<string, any>) {
  return useRequest().post('/oa_integration/update_ding_approval_record', params);
}

export async function delete_ding_approval_record(params: Record<string, any>) {
  return useRequest().post('/oa_integration/delete_ding_approval_record', params);
}

export async function recover_ding_approval_record(params: Record<string, any>) {
  return useRequest().post('/oa_integration/recover_ding_approval_record', params);
}

export async function query_ding_approval_record_list(params?: {
  [key: string]: any;
}): Promise<any> {
  return useRequest().post('/oa_integration/query_ding_approval_record_list', params);
}

export async function query_ding_approval_record_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_approval_record_group', params);
}

export async function query_ding_approval_record_count(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_approval_record_count', params);
}

export async function get_ding_approval_record(params: Record<string, any>) {
  return useRequest().post('/oa_integration/get_ding_approval_record', params);
}

export async function create_ding_form_component(params: Record<string, any>) {
  return useRequest().post('/oa_integration/create_ding_form_component', params);
}

export async function update_ding_form_component(params: Record<string, any>) {
  return useRequest().post('/oa_integration/update_ding_form_component', params);
}

export async function delete_ding_form_component(params: Record<string, any>) {
  return useRequest().post('/oa_integration/delete_ding_form_component', params);
}

export async function recover_ding_form_component(params: Record<string, any>) {
  return useRequest().post('/oa_integration/recover_ding_form_component', params);
}

export async function query_ding_form_component_list(params?: {
  [key: string]: any;
}): Promise<any> {
  return useRequest().post('/oa_integration/query_ding_form_component_list', params);
}

export async function query_ding_form_component_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_form_component_group', params);
}

export async function query_ding_form_component_count(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_form_component_count', params);
}

export async function get_ding_form_component(params: Record<string, any>) {
  return useRequest().post('/oa_integration/get_ding_form_component', params);
}

export async function create_ding_form_component_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/create_ding_form_component_org', params);
}

export async function update_ding_form_component_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/update_ding_form_component_org', params);
}

export async function delete_ding_form_component_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/delete_ding_form_component_org', params);
}

export async function recover_ding_form_component_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/recover_ding_form_component_org', params);
}

export async function query_ding_form_component_org_list(params?: {
  [key: string]: any;
}): Promise<any> {
  return useRequest().post('/oa_integration/query_ding_form_component_org_list', params);
}

export async function query_ding_form_component_org_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_form_component_org_group', params);
}

export async function query_ding_form_component_org_count(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_ding_form_component_org_count', params);
}

export async function get_ding_form_component_org(params: Record<string, any>) {
  return useRequest().post('/oa_integration/get_ding_form_component_org', params);
}

export async function create_remote_select_info(params: Record<string, any>) {
  return useRequest().post('/oa_integration/create_remote_select_info', params);
}

export async function update_remote_select_info(params: Record<string, any>) {
  return useRequest().post('/oa_integration/update_remote_select_info', params);
}

export async function delete_remote_select_info(params: Record<string, any>) {
  return useRequest().post('/oa_integration/delete_remote_select_info', params);
}

export async function recover_remote_select_info(params: Record<string, any>) {
  return useRequest().post('/oa_integration/recover_remote_select_info', params);
}

export async function query_remote_select_info_list(params?: { [key: string]: any }): Promise<any> {
  return useRequest().post('/oa_integration/query_remote_select_info_list', params);
}

export async function query_remote_select_info_group(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_remote_select_info_group', params);
}

export async function query_remote_select_info_count(params: Record<string, any>) {
  return useRequest().post('/oa_integration/query_remote_select_info_count', params);
}

export async function get_remote_select_info(params: Record<string, any>) {
  return useRequest().post('/oa_integration/get_remote_select_info', params);
}
